export enum SvgGradients {
  Red = "red-gradient",
  RedFaded = "red-faded-gradient",
  Blue = "blue-gradient",
  Green = "green-gradient",
}

export enum GuidanceMode {
  Safety = "safety",
  Eco = "eco",
  Automatic = "auto",
  Combined = "combined",
}

export enum RpmSogMode {
  Sog = "sog",
  Rpm = "rpm",
}

export enum DashboardMode {
  Gauges = "gauges",
  Blocks = "simple",
  Chart = "chart",
  Automatic = "auto",
}

export enum RecommendedSogType {
  Eco = "eco",
  Safety = "safety",
}
